<template>
  <!-- 促销规则管理 -->
  <div class="promRuleList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['促销管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('', 'GZH', '', 1)"
          >新增组合
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('', 'DZK', '', 1)"
          >新增折扣
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('', 'DMJ', '', 1)"
          >新增满减
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('', 'DMZ', '', 1)"
          >新增买赠
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('', 'DHG', '', 1)"
          >新增换购
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('', 'DQG', '', 1)"
          >新增抢购
        </el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">方案类型：</label>
        <el-select
          v-model="searchForm.showType"
          placeholder="方案类型"
          style="width: 100px; margin-right: 5px"
          clearable
        >
          <el-option label="全部分类" value=""></el-option>
          <el-option label="换购" value="DHG"></el-option>
          <el-option label="买赠" value="DMZ"></el-option>
          <el-option label="折扣" value="DZK"></el-option>
          <el-option label="抢购" value="DQG"></el-option>
          <el-option label="满减" value="DMJ"></el-option>
          <el-option label="组合" value="GZH"></el-option>
        </el-select>
        <label class="label">方案状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="方案状态"
          style="width: 100px; margin-right: 5px"
          clearable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="已上架" value="2"></el-option>
          <el-option label="未上架" value="1"></el-option>
          <el-option label="已删除" value="0"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 150px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
        >
        </el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="entName"
        show-overflow-tooltip
        label="机构名称"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="id"
        show-overflow-tooltip
        label="规则编号"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        show-overflow-tooltip
        label="规则标题"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="typeName"
        show-overflow-tooltip
        label="规则类型"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="remarks"
        show-overflow-tooltip
        label="规则说明"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | formatType">{{
            scope.row.status | formatStatus
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="
              handleAdd(
                scope.row.id,
                scope.row.type,
                scope.row.entId,
                scope.row.status
              )
            "
            v-show="scope.row.status != 0"
          >
            {{ scope.row.status == 1 ? "编辑" : "查看" }}
          </el-button>
          <el-button
            type="success"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 2)"
            v-show="scope.row.status == 1"
            >上架</el-button
          >
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 1)"
            v-show="scope.row.status == 2"
            >下架</el-button
          >
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 0)"
            v-show="scope.row.status == 1"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>该界面维护促销活动的促销规则</p>
        <p>查看：可查看规则详情</p>
        <p>下架：禁用该促销规则，禁用后该规则可进行编辑</p>
        <p>
          备注：新增促销活动顺序为
          <span style="font-weight: bold"
            >新增促销规则 -> 上架 -> 新增促销活动 -> 上架</span
          >
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//混入
import { formatStatus } from "@/mixins/filters/formatStatus.js";

export default {
  name: "promRuleList",
  mixins: [formatStatus],
  data() {
    return {
      /**表格数据 */
      // {
      //   entId:"机构",
      //   entName:"机构名称",
      //   id:"规则编号",
      //   name:"规则标题",
      //   typeName:"规则类型名称",
      //   type:"规则类型",
      //   remarks:"规则说明",
      //   status:"状态",
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      selectedList: [],
      /**搜索表单 */
      searchForm: {
        showType: "", // 方案类型
        status: "", // 方案状态
        name: "",
      },

      /**使用说明 */
      explain: false,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      var data = {
        type: "QueryList",
        entId: window.localStorage.getItem("entId"),
        status: this.searchForm.status,
        faType: this.searchForm.showType,
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      this.$requestSys({
        url:
          "prom/ashx/PromRuleList.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)),
        method: "post",
      })
        .then((res) => {
          this.allPage = res.recordCount;
          this.tableData = [];
          if (res.flag == 0) {
            for (let i = 0; i < res.data.length; i++) {
              this.tableData.push({
                entId: res.data[i].entid,
                entName: res.data[i].entid,
                id: res.data[i].ruleCode,
                name: res.data[i].ruleTitle,
                typeName: res.data[i].faName,
                type: res.data[i].faType,
                remarks: res.data[i].describe,
                status: res.data[i].isShow,
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**点击新增/编辑 */
    handleAdd(id, type, entid, status) {
      let prams = encodeURIComponent(
        JSON.stringify({ id, type, entid, status })
      );
      this.$router.push({
        path: "addPromRule",
        query: {
          prams: prams,
        },
      });
    },
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let msgType = "info";
      let type = "UpdateRlueShow";
      if (status == 2) {
        msg = "确定上架吗?";
        msgType = "success";
        type = "UpdateRlueShow";
      } else if (status == 1) {
        msg = "确定下架吗?";
        msgType = "warning";
        type = "UpdateRlueDown";
      } else if (status == 0) {
        msg = "确定删除吗?";
        msgType = "error";
        type = "DeleteRlue";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: msgType,
      })
        .then(() => {
          let data = {
            type: type,
            ruleCode: row.id,
            entid: row.entId,
          };
          this.$requestSys({
            url:
              "prom/ashx/PromRuleList.ashx?json=" +
              encodeURIComponent(JSON.stringify(data)),
            method: "post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.promRuleList {
  width: 100%;
  height: 100%;
}
</style>
